export const SET_TOURNAMENTS = 'SET_TOURNAMENTS';

export const SELECT_TOURNAMENT = 'SELECT_TOURNAMENT';